import { ButtonHTMLAttributes, forwardRef } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownListItemButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button
    className={cn(
      'flex w-full flex-col items-start gap-1 px-2.5 py-2 text-gray-800 outline-none hover:bg-gray-100/80 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400',
      className
    )}
    ref={ref}
    {...props}
  />
))
